// extracted by mini-css-extract-plugin
module.exports = {"block":"Popover_block__UYW27"};